import React from 'react';
import PropTypes from 'prop-types';
import { Block, BlockContent, BlockImage, BlockTitle } from '../Block';

const ZoomBlock = ({ data }) => {
  return (
    <Block>
      {data?.detail?.title && <BlockTitle>{data.detail.title}</BlockTitle>}
      {data?.detail?.description && (
        <BlockContent wysiwyg>{data.detail.description}</BlockContent>
      )}
      {data?.image && <BlockImage src={data.image} withZoom />}
    </Block>
  );
};

ZoomBlock.propTypes = {
  data: PropTypes.object
};

export default ZoomBlock;
